import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

export default function LanguageDetector() {
  const router = useRouter()
  const [detectedLocale, setDetectedLocale] = useState(
    router.locale || router.defaultLocale
  )

  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return

    const browserLang = navigator.language || navigator.userLanguage
    const browserLocale = browserLang.startsWith('fr') ? 'fr' : 'en'

    if (browserLocale !== detectedLocale) {
      setDetectedLocale(browserLocale)
    }
  }, [detectedLocale])

  return null
}
